import { DocumentConnection } from '../../common/model/document-connection-base';
import { ModelBase } from '../../core/model/model-base';
import { BuildingDocumentType, BuildingDocumentTypeToString } from './const/documentEnums';

export class BuildingDocument extends DocumentConnection<BuildingDocumentType> {
  constructor() {
    super();
  }

  get connectionTypeText(): string {
    return BuildingDocumentTypeToString(this.connectionType);
  }

  buildingId: string;

  toJSON() {
    const result = super.toJSON();
    result['buildingId'] = this.buildingId;
    return result;
  }
}
